import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
// aos
import AOS from "aos";
import "aos/dist/aos.css";
import Layout from "../Layout/Layout";
import { useDispatch } from "react-redux";
import { sendMessage } from "../../states/actions/feedbackAction";
import { ToastContainer } from "react-toastify";
import TelegramShare from "../TelegramShare/TelegramShare";

const Contact = () => {
  // use effect
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 3000 });
  }, []);
  const dispatch = useDispatch();
  // use form
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const location = useLocation();
  const [email, setEmail] = useState("");

  // Prefill email if passed from FirstPage
  useEffect(() => {
    if (location.state?.email) {
      setValue("email", location.state.email); // prefill react-hook-form field
    }
  }, [location.state, setValue]);

  const [username, setUsername] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  // ========== Email Validation start here ==============
  const emailValidation = () => {
    return String(email)
      .toLocaleLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };
  // ========== Email Validation end here ================

  const handleSend = (e) => {
    e.preventDefault();
    if (username === "") {
      setErrMsg("Username is required!");
    } else if (phoneNumber === "") {
      setErrMsg("Phone number is required!");
    } else if (email === "") {
      setErrMsg("Please give your Email!");
    } else if (!emailValidation(email)) {
      setErrMsg("Give a valid Email!");
    } else if (message === "") {
      setErrMsg("Message is required!");
    } else {
      setSuccessMsg(
        `Thank you dear ${username}, Your Messages has been sent Successfully!`,
      );
      setErrMsg("");
      setUsername("");
      setPhoneNumber("");
      setEmail("");
      setSubject("");
      setMessage("");
    }
  };
  const onSubmit = (data, e) => {
    // console.log("message sent is : ", data);
    dispatch(sendMessage(data));
    reset();
  };
  return (
    <Layout
      title="Contact-Us Page | Aderaw Addisu Law Office"
      description="Legal services in Bahir Dar including arbitration, litigation, contracts and consultation."
      keywords="Legal services Bahir Dar, Lawyer Ethiopia"
    >
      <section className="pt-20">
        <section class="bg-white dark:bg-gray-900">
          <div class="container px-6 py-12 mx-auto">
            <div class="text-center ">
              <p class="font-medium text-blue-500 dark:text-blue-400">
                Contact us
              </p>

              <h1 class="mt-2 text-2xl font-semibold text-gray-800 md:text-3xl dark:text-white">
                We’d love to hear from you
              </h1>

              <p class="mt-3 text-gray-500 dark:text-gray-400">
                Chat to our friendly team.
              </p>
            </div>

            <img
              class="object-cover w-full h-64 mt-10 rounded-lg lg:h-96"
              src="https://images.unsplash.com/photo-1568992688065-536aad8a12f6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=100"
              alt="About us image"
            />

            <div class="grid grid-cols-1 gap-12 mt-10 lg:grid-cols-3 sm:grid-cols-2 ">
              <div class="p-4 rounded-lg bg-blue-50 md:p-6 dark:bg-gray-800">
                <span class="inline-block p-3 text-blue-500 rounded-lg bg-blue-100/80 dark:bg-gray-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-5 h-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                    />
                  </svg>
                </span>

                <h2 class="mt-4 text-base font-medium text-gray-800 dark:text-white">
                  Chat to sales
                </h2>
                <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
                  Speak to our friendly team.
                </p>
                <p class="mt-2 text-sm text-blue-500 dark:text-blue-400">
                  aderawadissu@gmail.com
                </p>
              </div>

              <div class="p-4 rounded-lg bg-blue-50 md:p-6 dark:bg-gray-800">
                <span class="inline-block p-3 text-blue-500 rounded-lg bg-blue-100/80 dark:bg-gray-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-5 h-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                    />
                  </svg>
                </span>

                <h2 class="mt-4 text-base font-medium text-gray-800 dark:text-white">
                  Visit us
                </h2>
                <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
                  Visit our office HQ..
                </p>
                <p class="mt-2 text-sm text-blue-500 dark:text-blue-400">
                  Near to Alcan College, Bahir Dar, Ethiopia
                </p>
              </div>

              <div class="p-4 rounded-lg bg-blue-50 md:p-6 dark:bg-gray-800">
                <span class="inline-block p-3 text-blue-500 rounded-lg bg-blue-100/80 dark:bg-gray-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-5 h-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                    />
                  </svg>
                </span>

                <h2 class="mt-4 text-base font-medium text-gray-800 dark:text-white">
                  Call us
                </h2>
                <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
                  Mon-Fri from 8am to 5pm.
                </p>
                <p class="mt-2 text-sm text-blue-500 dark:text-blue-400">
                  +2519-95 98 98 98 // +2519-18 78 43 07
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="text-gray-600 body-font relative">
          {/* Desktop / Tablet Map Background */}
          <div className="absolute inset-0 hidden md:block">
            <iframe
              width="100%"
              height="100%"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="map"
              scrolling="no"
              src="https://maps.google.com/maps?width=100%&height=600&hl=en&q=DarenGot+Technology+Solution&ie=UTF8&t=&z=14&iwloc=B&output=embed"
              alt="address photo"
            ></iframe>
          </div>

          <div className="container px-5 py-10 md:py-24 mx-auto flex flex-col md:flex-row">
            {/* Contact Form */}
            <div className="lg:w-1/3 md:w-1/2 bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full relative shadow-md">
              <form onSubmit={handleSubmit(onSubmit)}>
                <h2 className="text-gray-900 text-lg mb-1 font-medium title-font">
                  Get Trusted Legal Support
                </h2>

                <p className="leading-relaxed mb-5 text-gray-600">
                  Fill in your contact details and briefly describe your case.
                  Our dedicated legal team will reach out to discuss how we can
                  assist you.
                </p>

                {/* Name */}
                <div className="relative mb-2">
                  <label className="leading-7 text-sm text-gray-600">
                    Your Full Name
                  </label>
                  <input
                    type="text"
                    placeholder="Name"
                    className="w-full bg-white rounded border border-gray-300 focus:border-primary focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3"
                    {...register("name", { required: true })}
                  />
                  {errors.name && (
                    <p className="text-red-500">User Name required</p>
                  )}
                </div>

                {/* Phone */}
                <div className="relative mb-2">
                  <label className="leading-7 text-sm text-gray-600">
                    Phone Number *
                  </label>
                  <input
                    type="text"
                    placeholder="Phone No."
                    className="w-full bg-white rounded border border-gray-300 focus:border-primary focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3"
                    {...register("phone", { required: true })}
                  />
                  {errors.phone && (
                    <p className="text-red-500">Phone required</p>
                  )}
                </div>

                {/* Subject */}
                <div className="relative mb-2">
                  <label className="leading-7 text-sm text-gray-600">
                    Subject (optional)
                  </label>
                  <input
                    type="text"
                    placeholder="What is this regarding?"
                    className="w-full bg-white rounded border border-gray-300 focus:border-primary focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3"
                    {...register("subject")}
                  />
                </div>

                {/* Message */}
                <div className="relative mb-2">
                  <label className="leading-7 text-sm text-gray-600">
                    Message
                  </label>
                  <textarea
                    placeholder="Tell us about your case in a few words"
                    className="w-full bg-white rounded border border-gray-300 focus:border-primary focus:ring-2 focus:ring-indigo-200 h-24 text-base outline-none text-gray-700 py-1 px-3"
                    {...register("message", { required: true })}
                  ></textarea>
                  {errors.message && (
                    <p className="text-red-500">Message is required</p>
                  )}
                </div>

                <button
                  type="submit"
                  className="w-full text-white bg-primary py-2 px-6 hover:bg-indigo-600 rounded text-lg"
                >
                  Submit
                </button>

                <p className="text-xs text-gray-500 mt-3">
                  Thanks for sending your message, I will respond soon.
                </p>
              </form>
            </div>
          </div>

          {/* Mobile Map (Bottom) */}
          <div className="md:hidden w-full h-[300px] mt-6">
            <iframe
              width="100%"
              height="100%"
              frameBorder="0"
              title="map"
              scrolling="no"
              src="https://maps.google.com/maps?width=100%&height=600&hl=en&q=DarenGot+Technology+Solution&ie=UTF8&t=&z=14&iwloc=B&output=embed"
            ></iframe>
          </div>
        </section>
      </section>
      <ToastContainer />
      <TelegramShare />
    </Layout>
  );
};

// export
export default Contact;
